// App-side endpoint map for the Check API only. Transport (axios, interceptors,
// idempotency, error shaping) lives in @my/platform/http. Directory endpoints
// live in @my/directory-api — import hooks from there, not from here. As Check
// grows, prefer the typed client + hooks in @my/check-api over hand-rolling
// endpoints here; this file mirrors the Depot app's `api/agent.ts` and exists
// mainly for the Diagnostics smoke-test.
import { request, type ApiInfo } from '@my/platform/http';

/** Endpoints scoped to the Check API (`/check/api/v1/*`). */
export const Check = {
  getApiInfo: () => request.get<ApiInfo>('/check/api/v1/info/api-info'),
};

export const agent = { Check };
export type { ApiInfo };
